import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building2, Truck } from "lucide-react";

export function CommercialCta() {
  return (
    <section className="py-20 lg:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-center border border-slate-200 bg-white p-10 lg:p-14">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Building2 className="h-5 w-5 text-primary-brand" />
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-primary-brand">Ready to Ship?</div>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-black tracking-tight text-slate-900">
            Let's build a route that fits your business.
          </h2>
          <p className="mt-4 text-slate-600">
            Whether it's a single load or a weekly contract, we'll match the right truck,
            the right driver, and the right window to your operation.
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-4">
          <Link
            to="/quote"
            data-testid="commercial-quote-cta-footer"
            className="inline-flex items-center gap-2 bg-primary-brand hover:bg-[#E04F00] text-white px-8 py-4 font-bold uppercase tracking-wider text-sm"
          >
            Request a Free Quote <ArrowRight className="h-4 w-4" />
          </Link>
          <div className="flex items-center gap-2 text-sm">
            <Truck className="h-4 w-4 text-primary-brand" />
            <span className="text-slate-600">Headquartered in Salt Lake City, UT — serving all 50 states.</span>
          </div>
        </div>
      </div>
    </section>
  );
}
